// extracted by mini-css-extract-plugin
export default {"Slot":"Slot_Slot__xZuw2","Highlighted":"Slot_Highlighted__7Je-D","embiggen":"Slot_embiggen__gzyLm"};